/***
*
*   OTP
*   User must enter a OTP here if they have enabled 2FA.
*
**********/

import { useContext, useState, useCallback } from 'react';
import { AuthContext, Form, useSearchParams } from 'components/lib';

export function SigninOTP({ t }){

  const authContext = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const [codeInput, setCodeInput] = useState({
    type: 'otp',
    label: t('auth.signin.otp.form.code.label'),
    required: true,
  });
  const [usingBackup, setUsingBackup] = useState(false);

  const useBackupCode = useCallback(() => {
    setCodeInput({
      label: 'Backup code',
      type: 'text',
      required: true,
    });
    setUsingBackup(true);
  }, []);

  const useAuthenticator = useCallback(() => {
    setCodeInput({
      label: t('auth.signin.otp.form.code.label'),
      type: 'otp',
      required: true,
    });
    setUsingBackup(false);
  }, [t]);

  return (
    <div className="space-y-6">

      <div className="text-center space-y-3">
        <div
          className="w-14 h-14 mx-auto rounded-full glass-card dark:glass-card-dark flex items-center justify-center shadow-lg fade-in"
          aria-hidden="true"
        >
          <svg
            className="w-6 h-6 text-white/90"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.6}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 3l7 3v6c0 4.5-3.1 7.9-7 9-3.9-1.1-7-4.5-7-9V6l7-3z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
          </svg>
        </div>

        <h1 className="text-2xl sm:text-3xl font-light text-white fade-in tracking-wide">
          {usingBackup ? 'Enter Backup Code' : t('auth.signin.otp.title')}
        </h1>

        <p
          className="text-white/70 text-sm font-light slide-up max-w-xs mx-auto leading-relaxed"
          style={{ animationDelay: '0.1s' }}
        >
          {usingBackup
            ? 'Enter one of your saved backup codes to sign in.'
            : t('auth.signin.otp.description')}
        </p>
      </div>

      <div className="scale-in" style={{ animationDelay: '0.3s' }}>
        <Form
          method="post"
          url="/api/auth/otp"
          inputs={{
            code: codeInput,
            jwt: {
              type: 'hidden',
              value: searchParams.get('token'),
            },
          }}
          buttonText={t('auth.signin.otp.form.button')}
          callback={authContext.signin}
        />
      </div>

      <div
        className="text-center slide-up border-t border-white/10 pt-4"
        style={{ animationDelay: '0.5s' }}
      >
        {usingBackup ? (
          <button
            type="button"
            onClick={useAuthenticator}
            className="text-white/80 hover:text-white text-xs font-light tracking-wide underline underline-offset-4 transition-colors"
          >
            Use authenticator app instead
          </button>
        ) : (
          <div className="space-y-1">
            <p className="text-white/50 text-xs font-light">
              {t('auth.signin.otp.footer.text')}
            </p>
            <button
              type="button"
              onClick={useBackupCode}
              className="text-white/80 hover:text-white text-xs font-light tracking-wide underline underline-offset-4 transition-colors"
            >
              {t('auth.signin.otp.footer.button')}
            </button>
          </div>
        )}
      </div>

    </div>
  );
}
